import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      settings: {},
      officials: [],

      setUser: (user) => set({ user, isAuthenticated: true }),
      setToken: (token) => set({ token }),
      setSettings: (settings) => set({ settings }),
      setOfficials: (officials) => set({ officials }),

      login: (user, token) => {
        localStorage.setItem("isStudentAuth", token);
        localStorage.setItem("isStudent", JSON.stringify(user));
        set({ user, token, isAuthenticated: true });
      },

      logout: () => {
        localStorage.removeItem("isStudentAuth");
        localStorage.removeItem("isStudent");
        set({ user: null, token: null, isAuthenticated: false });
      },

      getUser: () => get().user,

      checkAuth: () => {
        const token = localStorage.getItem("isStudentAuth");
        const userData = localStorage.getItem("isStudent");

        if (token && userData) {
          try {
            const user = JSON.parse(userData);
            set({ user, token, isAuthenticated: true });
            return true;
          } catch (error) {
            return false;
          }
        }
        return false;
      },
    }),
    {
      name: 'student-auth-storage',
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
        settings: state.settings,
        officials: state.officials,
      }),
    }
  )
);

export default useAuthStore;
